import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaBookmark, FaCalendarAlt, FaClock, FaUsers } from "react-icons/fa";
import { PopupDialog } from "../../components/popupDialog";
import { Status } from "../../constants/status";
import { TableName } from "../../constants/tableName";

export const MyReservations = ({
  myNormalReservations = [],
  myEventReservations = [],
  saveReservation = () => {},
}) => {
  const [open, setOpen] = useState(false);
  const [toggleType, setToggleType] = useState(Status.ACTIVE);
  const [activeNormalReservations, setActiveNormalReservations] = useState([]);
  const [completedNormalReservations, setCompletedNormalReservations] =
    useState([]);
  const [cancelledNormalReservations, setCancelledNormalReservations] =
    useState([]);
  const [activeEventReservations, setActiveEventReservations] = useState([]);
  const [completedEventReservations, setCompletedEventReservations] = useState(
    []
  );
  const [cancelledEventReservations, setCancelledEventReservations] = useState(
    []
  );
  const [selectedReservation, setSelectedReservation] = useState({});
  const [type, setType] = useState(null);
  const isCancellable = (reservationDate, startTime) => {
    return (
      new Date(`${reservationDate}T${startTime}`) - new Date() >=
      24 * 60 * 60 * 1000
    );
  };

  const reservationCard = ({ reservation, showButton = true, type = null }) => {
    return (
      <div key={reservation?.id} className="reservation-card">
        <div className="card-header">
          <h4>{reservation?.timeSlot?.slotTitle}</h4>
        </div>
        <div className="card-body">
          <p>
            <FaBookmark />
            {`ID: ${reservation?.id}`}
          </p>
          <p>
            <FaCalendarAlt />
            {`Reservation Date: ${reservation?.reservationDate}`}
          </p>
          <p>
            <FaClock />
            {`Time Slot: ${reservation?.timeSlot?.startTime} - ${reservation?.timeSlot?.endTime}`}
          </p>
          <p>
            <FaUsers /> {`Pax: ${reservation?.pax}`}
          </p>
          {showButton && (
            <Button
              className={
                !isCancellable(
                  reservation?.reservationDate,
                  reservation?.timeSlot?.startTime
                )
                  ? "arrow-button-disabled"
                  : ""
              }
              onClick={
                isCancellable(
                  reservation?.reservationDate,
                  reservation?.timeSlot?.startTime
                )
                  ? () => {
                      handlePopup(reservation);
                      setType(type);
                    }
                  : () => {}
              }
            >
              CANCEL RESERVATION
            </Button>
          )}
        </div>
      </div>
    );
  };
  const handlePopup = (reservation) => {
    setSelectedReservation(reservation);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
    saveReservation(selectedReservation.id, type);
  };
  const handleToggle = (value) => {
    setToggleType(value);
  };
  useEffect(() => {
    setActiveNormalReservations(
      myNormalReservations.filter((data) => data.status === Status.ACTIVE)
    );
    setCompletedNormalReservations(
      myNormalReservations.filter((data) => data.status === Status.COMPLETED)
    );
    setCancelledNormalReservations(
      myNormalReservations.filter((data) => data.status === Status.CANCELLED)
    );
    setActiveEventReservations(
      myEventReservations.filter((data) => data.status === Status.ACTIVE)
    );
    setCompletedEventReservations(
      myEventReservations.filter((data) => data.status === Status.COMPLETED)
    );
    setCancelledEventReservations(
      myEventReservations.filter((data) => data.status === Status.CANCELLED)
    );
  }, [myNormalReservations, myEventReservations]);

  return (
    <div>
      <div>
        <h3>My Reservations</h3>
        <hr />
        <div className="header-container">
          <div
            className={`header ${
              toggleType === Status.ACTIVE ? "selected-header" : ""
            }`}
            onClick={() => handleToggle(Status.ACTIVE)}
          >
            <label className="header-label">ACTIVE</label>
          </div>
          <div className="vertical-divider"></div>
          <div
            className={`header ${
              toggleType === Status.COMPLETED ? "selected-header" : ""
            }`}
            onClick={() => handleToggle(Status.COMPLETED)}
          >
            <label className="header-label">COMPLETED</label>
          </div>
          <div className="vertical-divider"></div>
          <div
            className={`header ${
              toggleType === Status.CANCELLED ? "selected-header" : ""
            }`}
            onClick={() => handleToggle(Status.CANCELLED)}
          >
            <label className="header-label">CANCELLED</label>
          </div>
        </div>
        <hr />
        {toggleType === Status.ACTIVE && (
          <div>
            <label>
              <span className="mandatory-field">*</span>
              The slot cancellation must be done
              <span className="mandatory-field"> AT LEAST 24 hours </span>before
              the reservation date. This applies to both normal and event slots.
            </label>
            <br />
            <br />
          </div>
        )}
        <h3>Normal Reservations</h3>
        {toggleType === Status.ACTIVE ? (
          activeNormalReservations.length < 1 ? (
            "No records."
          ) : (
            <div className="reservations-grid">
              {activeNormalReservations.map((reservation) =>
                reservationCard({
                  reservation: reservation,
                  type: TableName.NORMALRESERVATIONS,
                  showButton: true,
                })
              )}
            </div>
          )
        ) : toggleType === Status.COMPLETED ? (
          completedNormalReservations.length < 1 ? (
            "No records."
          ) : (
            <div className="reservations-grid">
              {completedNormalReservations.map((reservation) =>
                reservationCard({
                  reservation: reservation,
                  type: TableName.NORMALRESERVATIONS,
                  showButton: false,
                })
              )}
            </div>
          )
        ) : toggleType === Status.CANCELLED ? (
          cancelledNormalReservations.length < 1 ? (
            "No records."
          ) : (
            <div className="reservations-grid">
              {cancelledNormalReservations.map((reservation) =>
                reservationCard({
                  reservation: reservation,
                  type: TableName.NORMALRESERVATIONS,
                  showButton: false,
                })
              )}
            </div>
          )
        ) : null}
        <hr />
        <h3>Event Reservations</h3>
        {toggleType === Status.ACTIVE ? (
          activeEventReservations.length < 1 ? (
            "No records."
          ) : (
            <div className="reservations-grid">
              {activeEventReservations.map((reservation) =>
                reservationCard({
                  reservation: reservation,
                  type: TableName.EVENTRESERVATIONS,
                  showButton: true,
                })
              )}
            </div>
          )
        ) : toggleType === Status.COMPLETED ? (
          completedEventReservations.length < 1 ? (
            "No records."
          ) : (
            <div className="reservations-grid">
              {completedEventReservations.map((reservation) =>
                reservationCard({
                  reservation: reservation,
                  type: TableName.EVENTRESERVATIONS,
                  showButton: false,
                })
              )}
            </div>
          )
        ) : toggleType === Status.CANCELLED ? (
          cancelledEventReservations.length < 1 ? (
            "No records."
          ) : (
            <div className="reservations-grid">
              {cancelledEventReservations.map((reservation) =>
                reservationCard({
                  reservation: reservation,
                  type: TableName.EVENTRESERVATIONS,
                  showButton: false,
                })
              )}
            </div>
          )
        ) : null}
      </div>
      <PopupDialog
        name="confirmationPopup"
        open={open}
        onClose={handleClose}
        title="Cancellation Confirmation"
        content={
          <div>
            {
              <div>
                <h4 className="confirmation-description">
                  Are you sure you want to cancel this reservation?
                </h4>
                {reservationCard({
                  reservation: selectedReservation,
                  showButton: false,
                })}
              </div>
            }
          </div>
        }
        positiveAction={
          <Button onClick={handleCancel}>CANCEL RESERVATION</Button>
        }
        negativeAction={<Button onClick={handleClose}>CLOSE</Button>}
      />
    </div>
  );
};
